import {
    REQUEST_LOST_ITEMS,
    REQUEST_LOST_ITEMS_SUCCESS,
    REQUEST_LOST_ITEMS_FAILURE
} from "../../constant/other/LostItemConstant";

const initialState = {
    lostItems: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const lostItemsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_LOST_ITEMS:
            return {
                ...state,
                lostItems: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_LOST_ITEMS_SUCCESS:
            return {
                ...state,
                lostItems: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_LOST_ITEMS_FAILURE:
            return {
                ...state,
                lostItems: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
